function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withModifiers } from '../../decorators';
import { genId } from '../../helpers/generator';
import Text from '../text';

var TabsItem = function TabsItem(_ref) {
  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? genId() : _ref$id,
      _onClick = _ref.onClick,
      value = _ref.value,
      others = _objectWithoutProperties(_ref, ["active", "children", "className", "id", "onClick", "value"]);

  var _useState = useState(active),
      _useState2 = _slicedToArray(_useState, 2),
      _active = _useState2[0],
      setActive = _useState2[1]; // accessibility


  var a11y = {
    li: {
      role: 'presentation'
    },
    a: {
      role: 'tab',
      'aria-selected': _active
    }
  };
  React.useEffect(function () {
    setActive(active);
  }, [active]);
  return React.createElement("li", _extends({
    className: classNames(className, {
      'is-active': _active
    })
  }, a11y.li, others, {
    onClick: function onClick(e) {
      setActive(active);
      e.target.active = active;
      _onClick && _onClick(e);
    }
  }), children && typeof children.valueOf() === 'string' ? React.createElement(TabsItem.Text, _extends({
    asTag: "a",
    tabIndex: true
  }, a11y.a, others, {
    content: children
  })) : React.cloneElement(children, _objectSpread({}, a11y.a, {}, others)));
};

TabsItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  id: PropTypes.string,
  value: PropTypes.any
};
TabsItem.defaultProps = {
  active: false
};
TabsItem.Text = Text;
TabsItem.displayName = 'Tabs.Item';
export default withModifiers(TabsItem);